<template>
  <v-card max-width="300" height="200" style="margin-bottom:20px !important;" >
       <v-card-title class="justify-center pb-0" >
           Covid Summery
          </v-card-title>
    <v-list-item two-line>
      <v-list-item-content class="pa-0">
        <v-list-item-title class="text-h4">
          India
        </v-list-item-title>
        <v-list-item-subtitle>{{dateBuilder(covid_data.Date)}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text >
      <v-row no-gutters>
        <v-col class="subtitle-1" cols="6" >
          Total Cases:
        </v-col>
        <v-col class="subtitle-1" cols="6" >
          {{covid_data.TotalConfirmed|comma}}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="subtitle-1" cols="6" >
          Total Deaths:
        </v-col>
        <v-col class="subtitle-1" cols="6" >
          {{covid_data.TotalDeaths|comma}}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
  export default {
    name: 'Covid',

    data: () => ({
      api_key: 'd7b8e164e93545099bc5803b1c156e9e',
      url_base: 'https://api.covid19api.com/summary',
      query:'Delhi',
      covid:[],
      covid_data:{},
      
    }),
    created () {
      this.fetchCovid('Enter');
    },
    methods:{
        fetchCovid(){
            fetch(`${this.url_base}`).then(
                res => {
                    return res.json();
                }).then(this.setResults);
                
            
        },
        setResults(results){
            this.covid = results;
            this.covid_data = this.covid.Countries.find((item) => 
             item.Country === 'India'
            //  console.log(country)
          )
        },
        dateBuilder(d){
            return  moment(d).format('llll');
        },
        number(x) {
          return x.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }
  }
</script>
